import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_right",
  "use": "arrow_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_right\">\n<title>arrow_right</title>\n<path d=\"M9.984 17.016v-10.031l5.016 5.016z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol